<template>
    <div class="img-generator-box">
        <div v-if="null != obj">
            <div v-html="obj.code" ref="htmlCodeScreenshotDom" :style="{width: domWidth, height: domHeight}">

            </div>
        </div>
    </div>
</template>

<script setup>
    import {inject, ref, onMounted, toRef, getCurrentInstance, onBeforeMount, computed} from "vue";
    import html2canvas from "html2canvas";

    const props = defineProps(["obj"])
    const emits = defineEmits(["success-complete"])

    const { proxy } = getCurrentInstance()

    const domWidth = computed(() => {
        let width = null

        if (null != props.obj && null != props.obj.width){
            return `${props.obj.width}px`
        }

        return width
    })

    const domHeight = computed(() => {
        let height = null

        if (null != props.obj && null != props.obj.height){
            return `${props.obj.height}px`
        }

        return height
    })

    async function screenShot(){
        html2canvas(proxy.$refs.htmlCodeScreenshotDom,{timeout: 250})
            .then(canvas => { //scala默认1 控制字体线条粗细
                // var context = canvas.getContext("2d")
                // context.drawImage(canvas, 0, 0, 425, 275)
                // var data = context.getImageData(0, 0, 425, 275)
                // canvas.width = 425
                // canvas.height = 275
                // context.putImageData(data, 0, 0)
                // context.drawImage(canvas, 0, 0, 425, 275)
                // value.memberworkImgFile = canvas.toDataURL("image/jpeg", 0.8)
                // box.remove()
                // update(value)
                const imgBase64 = canvas.toDataURL("image/jpeg")

                emits("success-complete", props.obj, imgBase64)

            });
    }

    onMounted(() => {
        if (null == props.obj){
            emits("success-complete")
        }

        screenShot()
    })

</script>

<style scoped>
    .img-generator-box {
        position: fixed;
        left: 0;
        top: 200vh;
        background: #fff;
    }
</style>